const relativePathFromBase = (base: string, absolute: string) => {
  if (absolute === base || absolute === `${base}/`) {
    return '';
  }
  if (absolute.startsWith(`${base}/`)) {
    return absolute.slice(base.length + 1);
  }
  return absolute;
};

export { relativePathFromBase };
